import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { GetPlaylistDto } from '../../../dto/getplaylist/getplaylistdto';

export interface GetPlaylistRequest extends APIRequest
{
    getGetPlaylistRequest(): GetPlaylistDto;
}

export class GetPlaylistRequestImpl extends APIRequestDtoImpl implements GetPlaylistRequest
{
    constructor(private playlistData: GetPlaylistDto)
    {
        super();
    }

    getGetPlaylistRequest(): GetPlaylistDto
    {
        return this.playlistData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getplaylist/getplaylistrequest.tsx